import { executeVSCodeCommand } from "utils/vscode";

import type { Command } from "../../types";

export const useOpenProjectSetup = (): Command => {
  return {
    id: "codesandbox.projectSetup.open",
    name: "Project setup",
    section: "Setup",
    perform: () => {
      executeVSCodeCommand("codesandbox.openCsbTab", {
        type: "ENV_SETUP",
      });
    },
  };
};
